export const CREATE_GROUP = 'app/Groups/CREATE_GROUP'
export const CREATE_GROUP_DONE = 'app/Groups/CREATE_GROUP_DONE'
export const CREATE_GROUP_ERROR = 'app/Groups/CREATE_GROUP_ERROR'

export const groupTypeOptions = {
  GROUP: 'Group',
  FILTER_GROUP: 'FilterGroup'
}

export const groupsActiveFilterOptions = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  ALL: 'All'
}

export const groupsQuickFilterOptions = {
  ALL: 'All',
  CREATED_BY_ME: 'CreatedByMe',
  CREATED_BY_OTHERS: 'CreatedByOthers'
}

export const groupsSortOptions = {
  NAME: 'Name',
  TYPE: 'Type',
  CREATED: 'Created',
  LAST_MODIFIED: 'LastModified'
}

export const groupsSortDirectionOptions = {
  ASC: 'ASC',
  DESC: 'DESC'
}

export const groupsPageSizeOptions = [25, 50, 100]

export const groupsListDefaults = {
  search: '',
  activeFilter: groupsActiveFilterOptions.ACTIVE,
  quickFilter: groupsQuickFilterOptions.ALL,
  type: undefined,
  sort: groupsSortOptions.NAME,
  direction: groupsSortDirectionOptions.DESC,
  page: 0,
  size: groupsPageSizeOptions[0]
}
